// @flow
import { sortArray } from '../../utils/sort/sort'
import {
  CHANGE_ACTIVE_SORT,
  CHANGE_ERROR_STATE,
  TOGGLE_INITIAL_MOUNT
} from '../../actionTypes/parametersTypes'
import { SELECT_VALUE } from '../../actionTypes/searchTypes'

import * as actionTypes from '../../actionTypes/datasetTypes'

const { SET_SHOWING_DATASET, RESET_SHOWING_DATASET, UPDATE_ROOT_DATASET } = actionTypes

export function editShowingDataset(selected?: Object, method?: Object): Function {
  return function(dispatch: Function, getState: Function): void {
    const { search, parameters, dataset } = getState()

    if (!parameters.isNotInitialMount) {
      dispatch({ type: TOGGLE_INITIAL_MOUNT })
    }

    if (selected) {
      if (!selected.relatedChecked) {
        const related = parameters.hasRelated ? relatedCheck(selected, dataset.related) : []
        const selectedToSet = {
          ...selected,
          related,
          relatedCheck: true
        }

        dispatch(updateRootDataset(dataset.rootData, selectedToSet))
        dispatch({
          type: SELECT_VALUE,
          selected: selectedToSet,
          method
        })
      } else {
        dispatch({
          type: SELECT_VALUE,
          selected,
          method
        })
      }
      dispatch(changeSort(parameters.afterSelectSort))
    } else if (search.selected) {
      dispatch(changeSort(parameters.afterSelectSort))
    } else {
      dispatch({
        type: CHANGE_ERROR_STATE,
        error: null
      })

      dispatch({
        type: CHANGE_ACTIVE_SORT,
        activeSort: parameters.initialSort
      })
      return dispatch(resetShowingDataset())
    }
  }
}

export function updateRootDataset(data: Array<Object>, selected: Object) {
  const index = data.findIndex(d => d.id === selected.id)
  let dataToSet = [...data]

  if (index >= 0 && selected) {
    dataToSet[index] = selected
  }
  return {
    type: UPDATE_ROOT_DATASET,
    rootData: dataToSet
  }
}

export function setShowingDataset(data: Array<Object>): Object {
  return {
    type: SET_SHOWING_DATASET,
    data
  }
}

export function resetShowingDataset(selected?: Object): Object {
  return (dispatch, getState) => {
    const { parameters, dataset } = getState()
    const { activeSort } = parameters
    const { rootData } = dataset

    let data
    if (selected && selected.id) {
      data = sortArray([...rootData], activeSort)
        .filter(v => (selected && selected.id && v.id ? v.id !== selected.id : false))
        .slice(0, parameters.showingLengths[0])
    } else if (activeSort.type !== 'NONE') {
      data = sortArray([...rootData], activeSort).slice(0, parameters.showingLengths[0])
    }

    if (activeSort.type !== 'NONE') {
      dispatch(changeSort(activeSort))
    } else if (activeSort.type === 'RELATED' || activeSort.hidden) {
      dispatch(changeSort(null))
    } else {
      dispatch(changeSort(activeSort))
      data = rootData.slice(0, parameters.showingLengths[0])
    }
    dispatch({
      type: RESET_SHOWING_DATASET,
      data
    })
  }
}

export function setRelated(selected: Object, sort: ?Object) {
  return (dispatch: Function, getState: Function): Object => {
    const { dataset, parameters } = getState()
    const { rootData } = dataset
    const { initialSort } = parameters

    const { related } = getState().search.selected
    const relatedData = sortArray([...rootData].filter(r => related.includes(r.id)), initialSort)

    return dispatch(setShowingDataset(relatedData))
  }
}

function sortASCorDESC(sort: Object): Function {
  return (dispatch: Function, getState: Function): Function => {
    const { search, dataset, parameters } = getState()
    const { selected } = search
    const { rootData } = dataset
    const length = parameters.showingLengths[0]

    return dispatch({
      type: SET_SHOWING_DATASET,
      data: sortArray(rootData.slice(0), sort)
        .filter(v => {
          if (selected) {
            return selected.id !== v.id
          }
          return true
        })
        .slice(0, length)
    })
  }
}

export function changeSort(sort: ?Object): Function {
  return (dispatch, getState) => {
    const { parameters, search } = getState()
    const { activeSort, initialSort, afterSelectSort, hasRelated } = parameters
    const selected = search.selected
    if (!sort) sort = selected ? afterSelectSort : initialSort

    if (sort.type === 'NONE') return
    if (sort.type === 'RELATED' && selected && hasRelated) {
      if (selected.related) {
        dispatch(setRelated(selected, sort))

        return dispatch({
          type: CHANGE_ACTIVE_SORT,
          activeSort: sort
        })
      } else {
        sort = parameters.initialSort
      }
    }
    if (sort.type === 'PLACEMENT' && selected) {
      dispatch(sortPlacedNear(sort, selected))
      return dispatch({
        type: CHANGE_ACTIVE_SORT,
        activeSort: sort
      })
    }

    let { sortDir, sortRow } = sort

    switch (sortDir) {
      case 'ALTERNATE':
        if (activeSort.sortDir === 'DESC' && parameters.activeSort.sortRow === sortRow) {
          dispatch(sortASCorDESC(decodeSortType('ASC', sortRow, parameters.availableSorts)))
        } else {
          dispatch(sortASCorDESC(decodeSortType('DESC', sortRow, parameters.availableSorts)))
        }
        break
      case 'ASC':
        dispatch(sortASCorDESC(sort))
        break
      case 'DESC':
      default:
        dispatch(sortASCorDESC(sort))
        break
    }
    return dispatch({
      type: CHANGE_ACTIVE_SORT,
      activeSort: sort
    })
  }
}

function relatedCheck(selected: Object, related: Array<Object>): Array<string> | false {
  const { id } = selected

  const findRelatedIds = () => {
    const row = related.find(r => r.id === id)
    if (!row || !row.related) return []
    return row.related.split(';')
  }
  const relatedIds = findRelatedIds()

  if (relatedIds && relatedIds.length) return relatedIds
  return false
}

function sortPlacedNear(sort: Object, selected: Object): Object {
  return (dispatch, getState) => {
    const { dataset, parameters } = getState()
    const { rootData } = dataset
    const { initialSort, showingLengths } = parameters

    const array = sortArray(rootData.slice(0), initialSort)
    const idx = array.indexOf(selected)

    let lowIdx, highIdx

    if (idx === 0) {
      lowIdx = 0
      highIdx = showingLengths[0]
    } else if (rootData.length - idx < 5) {
      lowIdx = rootData.length - 5
      highIdx = rootData.length
    } else {
      lowIdx = idx - 2
      highIdx = idx + 3
    }

    return dispatch({
      type: SET_SHOWING_DATASET,
      data: array.slice(lowIdx, highIdx)
    })
  }
}

function decodeSortType(sortDir, sortRow, availableSorts): Object {
  if (!availableSorts || !availableSorts.length) return {}
  const sorts = availableSorts.filter(a => a.sortDir === sortDir && a.sortRow === sortRow)
  return sorts && sorts[0] ? sorts[0] : {}
}



// WEBPACK FOOTER //
// ./src/shared/actions/dataset/dataset.js